import { render, staticRenderFns } from "./GeneraSviluppoSostenibile.vue?vue&type=template&id=ea173738&scoped=true&"
import script from "./GeneraSviluppoSostenibile.vue?vue&type=script&lang=js&"
export * from "./GeneraSviluppoSostenibile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea173738",
  null
  
)

export default component.exports